import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {Store} from '@ngrx/store';
import {Apollo} from 'apollo-angular';
import {NotificationService} from 'src/app/services/notification.service';
import {ResponseCodeService} from 'src/app/services/response-code.service';
import {AppState} from 'src/app/store/reducers';
import * as fromActions from "./citizen-get-all-feedback-categories.actions";
import * as fromGraphql from "./citizen-get-all-feedback-categories.graphql"
import {map, switchMap} from 'rxjs';


@Injectable()
export class CitizenGetAllFeedbackCategoriesEffects {


  citizenGetAllFeedbackCategories$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.citizenGetAllFeedbackCategories),
    switchMap((action) => {
      return this.apollo.query({
        query: fromGraphql.GET_CITI_ALL_FEEDBACK_CATEGORIES,
        fetchPolicy: 'network-only'
      }).pipe(
        this.notificationService.catchError('Problem occurred while fetching service categories'),
        map(({ data }: any ) => {
          if (data) {
            const result: any = Object.values(data)[0]
            result?.response?.status ? this.store.dispatch(fromActions.loadCitizenGetAllFeedbackCategoriess({ citizenGetAllFeedbackCategoriess: result?.data })) : []
          }
        })
      );
    })
  ), { dispatch: false });

  constructor(
    private actions$: Actions,
    private apollo: Apollo,
    private store: Store<AppState>,
    private notificationService: NotificationService,
    private responseCodesService: ResponseCodeService
  ) {}
}
